<template>
  <div class="wrapper">
    <div
      class="section section-signup page-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
          >
            <md-card class="cardsession">
              <md-card-header
                style="background: linear-gradient(80deg, #f95050, #1818fa)"
              >
                <h3 style="text-align:center" class="stitle" v-if="!id">
                  Ajouter une nouvelle session utilisateur
                </h3>

                <h3 v-if="id" style="text-align:center" class="stitle">
                  Modification de l'activité
                </h3>
              </md-card-header>

              <form @submit="createSessionActivitee">
                <md-field v-if="id" class="formSession">
                  <label>Ajouter une date</label>
                  <md-input v-model="data.date"></md-input>
                </md-field>

                <md-field v-if="!id">
                  <input
                    type="date"
                    id="date"
                    v-model="data.date"
                    required
                    style="width: 100%; box-sizing: border-box; height: 50px;"
                  />
                </md-field>
                <!--  v-bind:max="maxDate"
                    v-bind:min="minDate" -->
                <!-- <md-autocomplete
                  v-model="data.selectedAntennes"
                  :md-options="antennes"
                  md-layout="box"
                  class="formSession"
                  ><label>Choix antennes</label>
                </md-autocomplete> -->
                <md-field class="select-box">
                  <label>Choisir une antenne</label>
                  <md-select
                    v-model="data.selectedAntennes"
                    :md-clearable="false"
                    md-layout="box"
                    class="formSession"
                  >
                    <md-option
                      v-for="antenne in antennes"
                      :key="antenne"
                      :value="antenne"
                    >
                      {{ antenne }}
                    </md-option>
                  </md-select>
                </md-field>

                <md-field class="select-box">
                  <label>Choisir une activité</label>
                  <md-select
                    v-model="data.selectedActivites"
                    :md-clearable="false"
                    md-layout="box"
                    class="formSession"
                  >
                    <md-option
                      v-for="activite in activites"
                      :key="activite"
                      :value="activite"
                    >
                      {{ activite }}
                    </md-option>
                  </md-select>
                </md-field>

                <!--   <md-autocomplete
                  v-model="data.selectedActivites"
                  :md-options="activites"
                  md-layout="box"
                  class="formSession"
                >
                  <label>Choisir une activité</label>
                  <template #md-autocomplete-input="{attrs}">
    <input
      v-bind="attrs"
      readonly
      disabled
    >
  </template>
                </md-autocomplete> -->
                <br />
                <!-- <label>Date de naissance</label>
                    <md-datepicker  format="dd/mm/yyyy"></md-datepicker> -->
                <vue-timepicker
                  v-model="data.heuredebut"
                  format="HH:mm"
                  :placeholder="'Selectionner l`heure de début'"
                  class="formSession"
                  @select="hideTimepicker"
                ></vue-timepicker>
                <br /><br />
                <vue-timepicker
                  v-model="data.heurefin"
                  format="HH:mm"
                  :placeholder="'Selectionner l`heure de fin'"
                ></vue-timepicker>
                <br />
                <br />
                <div>
                  <md-button
                    class=" md-primary md-round btnA"
                    color="red"
                    href="#/basic"
                    >Retour</md-button
                  >
                  <md-button type="submit" class="md-danger md-round">
                    Valider
                  </md-button>
                </div>
              </form>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { NavTabsCard } from "@/components";
import Timeselector from "vue-timeselector";
import axios from "../../http-common";
import { mapGetters } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import router from "../../router";
export default {
  bodyClass: "login-page",
  components: {
    VueTimepicker,
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  computed: {
    ...mapGetters(["user"]),

    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },

    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      data: {
        heuredebut: "",
        heurefin: "", // or new Date() to set preselect the picker
        selectedActivites: null,
        selectedAntennes: null,
        date: "",
      },
      activites: [
        "Collectes",
        "Centrale",
        "Commissions",
        "Direction",
        "Distribution alimentaire",
        "Education",
        "Educ pop",
        "Formations",
        "FD",
        "Friperie",
        "Maraudes",
        "Pole santé soin",
        "Autres initiatives",
      ],
      antennes: [],
      activite: null,
      maxDate: this.getCurrentMonthLastDay(),
      minDate: this.getCurrentMonthFirstDay(),
    };
  },

  methods: {
    getCurrentMonthFirstDay() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), 2)
        .toISOString()
        .slice(0, 10);
    },
    getCurrentMonthLastDay() {
      const now = new Date();
      const currentMonth = now.getMonth() + 1;
      const currentYear = now.getFullYear();
      const lastDay = new Date(currentYear, currentMonth, 0).getDate();
      const lastDayOfMonth = new Date(currentYear, currentMonth - 1, lastDay);
      const today = new Date();
      const maxDate = lastDayOfMonth > today ? today : lastDayOfMonth;
      return maxDate.toISOString().slice(0, 10);
    },

    selectAntennes() {
      // console.log("select antennes");
      axios
        .get("/antennes", { params: { nom: this.selectAntennes } })
        .then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            this.antennes.push(response.data[i].nom_antenne);
          }
          // this.antennes = response.data;
        })
        .catch(
          error // => console.log(error.response)
        );
    },
    hideTimepicker() {
        this.$nextTick(() => {
          const timepicker = this.$refs.timepicker;
          timepicker.isActive = false;
        });
      },

    createSessionActivitee(e) {
      e.preventDefault();
      //console.log(this.data);
      if (this.id) {
        axios
          .put(`activites/${this.id}`, {
            ...this.data,
            idutilisateur: this.user.id,
          })
          .then((response) => {
            console.log(response);
            router.push("/listeUnBenevole");
          })
          .catch((error) => console.log(error.message));
        // console.log("Modification des utilisateurs");
      } else {
        axios
          .post("/ajoutActivite", { ...this.data, idutilisateur: this.user.id })
          .then((response) => {
            /*  this.$swal("Félicitation!",
            "ACtivité ajoutée avec succès",
          "success") */
            //console.log(response);
            router.push("/basic");
          })
          .catch((error) =>
            //console.log(error.response)
            alert("L'heure de fin doit être supérieur à l'heure de debut")
          );
        //console.log("Création d'une session");
      }
    },

    getOneUser() {
      axios
        .get(`activites/${this.id}`)
        .then((response) => {
          //this. data.selectedActivites =  response.data.nom
          this.data.date = response.data.date;
          this.data.selectedActivites = response.data.nom;
          this.data.heuredebut = response.data.heuredebut;
          this.data.heurefin = response.data.heurefin;
          this.data.selectedAntennes = response.data.nom_antenne;

          console.log(response);
        })
        .catch((error) => console.log(error.message));
      //console.log("Modification d'un utilisateurs");
    },
  },

  created() {
    this.selectAntennes();
  },
  mounted() {
    this.getOneUser();
  },
};
</script>

<style lang="css">
.select-box {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  width: 100%;
}
.select-box .mdc-notched-outline__notch {
  border-bottom: none !important;
}
/* md-field {
 
  width: 1% !important;
  margin-right: auto;
  margin-left: auto;
}
.btnA {
  margin-top: 50px;
  margin-bottom: -200px;
}
.time{
  width:100px !important;
}  */
</style>


<template>
  <div class="wrapper">
    <div
      class="section section-signup page-header header-filter"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-33 md-medium-size-40 md-small-size-50 md-xsmall-size-70 mx-auto text-center"
          >
            <md-card class="cardsession">
              <md-card-header
                style="background: linear-gradient(80deg, #f95050, #1818fa)"
              >
                <h3 style="text-align:center" class="stitle" v-if="!id">
                  Ajouter une nouvelle session utilisateur
                </h3>

                <h3 v-if="id" style="text-align:center" class="stitle">
                  Modification de l'activité
                </h3>
              </md-card-header>

              <form @submit="createSessionActivitee">
                <md-field v-if="id" class="formSession">
                  <label>Ajouter une date</label>
                  <md-input v-model="data.date"></md-input>
                </md-field>

                <md-field v-if="!id">
                  <input
                    type="date"
                    id="date"
                    v-model="data.date"
                    required
                    style="width: 100%; box-sizing: border-box; height: 50px;"
                  />
                </md-field>
                <!--  v-bind:max="maxDate"
                    v-bind:min="minDate" -->
                <!-- <md-autocomplete
                  v-model="data.selectedAntennes"
                  :md-options="antennes"
                  md-layout="box"
                  class="formSession"
                  ><label>Choix antennes</label>
                </md-autocomplete> -->
                <md-field class="select-box">
                  <label>Choisir une antenne</label>
                  <md-select
                    v-model="data.selectedAntennes"
                    :md-clearable="false"
                    md-layout="box"
                    class="formSession"
                  >
                    <md-option
                      v-for="antenne in antennes"
                      :key="antenne"
                      :value="antenne"
                    >
                      {{ antenne }}
                    </md-option>
                  </md-select>
                </md-field>

                <md-field class="select-box">
                  <label>Choisir une activité</label>
                  <md-select
                    v-model="data.selectedActivites"
                    :md-clearable="false"
                    md-layout="box"
                    class="formSession"
                  >
                    <md-option
                      v-for="activite in activites"
                      :key="activite"
                      :value="activite"
                    >
                      {{ activite }}
                    </md-option>
                  </md-select>
                </md-field>

                <!--   <md-autocomplete
                  v-model="data.selectedActivites"
                  :md-options="activites"
                  md-layout="box"
                  class="formSession"
                >
                  <label>Choisir une activité</label>
                  <template #md-autocomplete-input="{attrs}">
    <input
      v-bind="attrs"
      readonly
      disabled
    >
  </template>
                </md-autocomplete> -->
                <br />
                <!-- <label>Date de naissance</label>
                    <md-datepicker  format="dd/mm/yyyy"></md-datepicker> -->
                <vue-timepicker
                  v-model="data.heuredebut"
                  format="HH:mm"
                  :placeholder="'Selectionner l`heure de début'"
                  class="formSession"
                  @select="hideTimepicker"
                ></vue-timepicker>
                <br /><br />
                <vue-timepicker
                  v-model="data.heurefin"
                  format="HH:mm"
                  :placeholder="'Selectionner l`heure de fin'"
                ></vue-timepicker>
                <br />
                <br />
                <div>
                  <md-button
                    class=" md-primary md-round btnA"
                    color="red"
                    href="#/basic"
                    >Retour</md-button
                  >
                  <md-button type="submit" class="md-danger md-round">
                    Valider
                  </md-button>
                </div>
              </form>
            </md-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { NavTabsCard } from "@/components";
import Timeselector from "vue-timeselector";
import axios from "../../http-common";
import { mapGetters } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import router from "../../router";
export default {
  bodyClass: "login-page",
  components: {
    VueTimepicker,
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/volunters.webp"),
    },
  },
  computed: {
    ...mapGetters(["user"]),

    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`,
      };
    },

    id() {
      return this.$route.params.id;
    },
  },
  data() {
    return {
      data: {
        heuredebut: "",
        heurefin: "", // or new Date() to set preselect the picker
        selectedActivites: null,
        selectedAntennes: null,
        date: "",
      },
      activites: [
        "Collectes",
        "Centrale",
        "Commissions",
        "Direction",
        "Distribution alimentaire",
        "Education",
        "Educ pop",
        "Formations",
        "FD",
        "Friperie",
        "Maraudes",
        "Pole santé soin",
        "Autres initiatives",
      ],
      antennes: [],
      activite: null,
      maxDate: this.getCurrentMonthLastDay(),
      minDate: this.getCurrentMonthFirstDay(),
    };
  },

  methods: {
    getCurrentMonthFirstDay() {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), 2)
        .toISOString()
        .slice(0, 10);
    },
    getCurrentMonthLastDay() {
      const now = new Date();
      const currentMonth = now.getMonth() + 1;
      const currentYear = now.getFullYear();
      const lastDay = new Date(currentYear, currentMonth, 0).getDate();
      const lastDayOfMonth = new Date(currentYear, currentMonth - 1, lastDay);
      const today = new Date();
      const maxDate = lastDayOfMonth > today ? today : lastDayOfMonth;
      return maxDate.toISOString().slice(0, 10);
    },

    selectAntennes() {
      // console.log("select antennes");
      axios
        .get("/antennes", { params: { nom: this.selectAntennes } })
        .then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            this.antennes.push(response.data[i].nom_antenne);
          }
          // this.antennes = response.data;
        })
        .catch(
          error // => console.log(error.response)
        );
    },
    hideTimepicker() {
        this.$nextTick(() => {
          const timepicker = this.$refs.timepicker;
          timepicker.isActive = false;
        });
      },

    createSessionActivitee(e) {
      e.preventDefault();
      const selectedAntenneName = this.data.selectedAntennes;

      // Recherche de l'antenne correspondante par son nom
              
      if (this.id) {
        axios.get("/antennes")  
          .then((response) => {
          const antennes = response.data;
          
          const selectedAntenne = antennes.find(antenne => antenne.nom_antenne === selectedAntenneName);
          
         
            const idAntenne = selectedAntenne.id;
            
              axios.put(`/activites/${this.id}`, {
                //...this.data,
                idutilisateur: this.user.id,
                nom: this.data.selectedActivites,
                idantenne: idAntenne,
                heuredebut:  this.data.heuredebut,
                heurefin: this.data.heurefin ,
                date: this.data.date 
                
              })
              .then((response) => {
                router.push("/listeUnBenevole");
              })
              .catch();
            })
        .catch();
      } else {
      axios
          .post("/ajoutActivite", { ...this.data, idutilisateur: this.user.id })
          .then((response) => {
              router.push("/basic");
          })
          .catch((error) => {
            //console.log(error.response)
            alert("L'heure de fin doit être supérieur à l'heure de debut")
          });
        //console.log("Création d'une session");
        }
    },

    getOneUser() {
      axios
        .get(`/activites/${this.id}`)
        .then((response) => {
          //this. data.selectedActivites =  response.data.nom
          this.data.date = response.data.date;
          this.data.selectedActivites = response.data.nom;
          this.data.heuredebut = response.data.heuredebut;
          this.data.heurefin = response.data.heurefin;
          this.data.selectedAntennes = response.data.nom_antenne;

          
        })
        .catch((error));
      //console.log("Modification d'un utilisateurs");
    }
  },

  created() {
    this.selectAntennes();
  },
  mounted() {
    this.getOneUser();
  },
};
</script>

<style lang="css">
.select-box {
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  width: 100%;
}
.select-box .mdc-notched-outline__notch {
  border-bottom: none !important;
}
/* md-field {
 
  width: 1% !important;
  margin-right: auto;
  margin-left: auto;
}
.btnA {
  margin-top: 50px;
  margin-bottom: -200px;
}
.time{
  width:100px !important;
}  */
</style>